import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { Home } from "../component/features/home/Home";
import { ClientRouter } from "./ClientRouter";
import { LocationRouter } from "./LocationRouter";
import { AssessmentRouter } from "./AssessmentRouter";
import { Profile } from "../component/profile/Profile";
import {  SchedulerRouter } from "./RunAssessmentRouter";
import { TakeAssessmentRouter } from "./TakeAssessmentRouter";
import { AssesseDahboard } from "../component/features/home/AssesseDashboard";
import { MessageRouter } from "../component/features/messages/MessageRouter";
import { SettingsRouter } from "./SettingsRouter";
import { ReportRouter } from "./ReportRouter";
import { AssignmentRouter } from "./AssignmentRouter";

const AppRouter = ({}) => {
    const isSidebarOpen = useSelector(state => state.sidebar.isOpen); 

    return (
        <Switch>
            <Route exact path="/">
                <Redirect to="/home" />
            </Route>
            <Route exact path="/home" component={Home} />
            <Route path="/profile" component={Profile} />
            <Route path="/locations" component={LocationRouter} />
            <Route path="/users" component={ClientRouter} />
            <Route path="/assessments" component={AssessmentRouter} />
            <Route path="/take-assessments" component={TakeAssessmentRouter} />
            <Route path="/scheduler" component={SchedulerRouter} />
            <Route path="/messages" component={MessageRouter} />
            <Route path="/settings" component={SettingsRouter} />
            <Route path="/reports" component={ReportRouter} />
            <Route path='/assignments' component={AssignmentRouter} />
            <Redirect to="/not-found" />
        </Switch>
    );
};

export default AppRouter;
